import {
    fetchQuery_DEPRECATED as fetchQuery,
    graphql,
    Environment,
    GraphQLTaggedNode,
} from 'react-relay/legacy';

import {
    checkHoldoutGroupQuery as queryType,
    HomepageHoldoutGroup,
} from './__generated__/checkHoldoutGroupQuery.graphql';

export const HOMEPAGE_GROUP_CONSUMER = 'consumer' as const;
export const HOMEPAGE_GROUP_TRADE = 'trade' as const;
export const HOMEPAGE_GROUP_CONTROL = 'control' as const;

export type HomepageGroupType = HomepageHoldoutGroup;

const checkHoldoutGroupQuery: GraphQLTaggedNode = graphql`
    query checkHoldoutGroupQuery($userId: String!) {
        viewer {
            homepageUserGroup(userId: $userId)
        }
    }
`;

export async function checkHoldoutGroup(
    relayEnv: Environment,
    userId: string
): Promise<HomepageGroupType> {
    let result = null;
    try {
        result = await fetchQuery<queryType>(relayEnv, checkHoldoutGroupQuery, {
            userId,
        });
    } catch (err) {
        return HOMEPAGE_GROUP_CONSUMER;
    }

    return result?.viewer?.homepageUserGroup || HOMEPAGE_GROUP_CONSUMER;
}
